// extracted by mini-css-extract-plugin
export default {"container":"prizes_container__r4ist","prize":"prizes_prize__DCw2A"};